/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type DataDictionaryGroupsEntryPointComponent = EntryPointComponent<
	{},
	{},
	{},
	{
		objectClassId?: string;
		dictionaryId?: string;
	}
>;

export const dataDictionaryGroupsEntryPoint: EntryPoint<
	DataDictionaryGroupsEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<DataDictionaryGroupsEntryPointComponent>(
		/* webpackChunkName: "async-data-dictionary-groups-page" */ './DataManagerDataDictionaryGroupsPage.tsx',
	),
	getPreloadProps: ({
		context: {
			match: { params },
		},
	}: EntryPointRouteParams) => ({
		extraProps: {
			objectClassId: params?.objectClassId || undefined,
			dictionaryId: params?.dictionaryId || undefined,
		},
	}),
});
